import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponsiveService } from '@service/responsive.service';

@Component({
    selector: 'app-dashboard-panel-header',
    templateUrl: './dashboard-panel-header.component.html',
    styleUrls: ['./dashboard-panel-header.component.scss'],
    standalone: false
})
export class DashboardPanelHeaderComponent {
    @Output() onDeleteClicked = new EventEmitter<void>();
    @Input() title: string = '';
    @Input() isPreview: boolean = false;

    constructor(public responsive: ResponsiveService) {}

    handleDeleteClicked() {
        this.emitDeleteClicked();
    }

    emitDeleteClicked() {
        this.onDeleteClicked.emit();
    }
}
